<template>
  <div class="bg-light w-screen md:max-w-lg h-screen md:h-auto flex flex-col justify-center">
    <ConfirmationCard
      :icon="ToppingIcon"
      :title="$t('text-confirm-top-ad-title', { name: localized(store.variant, 'name') })"
      :description="`${$t('text-available-topping-count')}: ${resolvedCount}<br>${$t('text-topping-24-hours-cost')}`"
      cancel-btn-class-name="border border-border-400 bg-transparent text-body hover:text-light hover:bg-gray-600 hover:border-gray-600 focus:ring-gray-600"
      confirm-btn-text="text-top-this-ad"
      :cancel-btn-loading="loading"
      :confirm-btn-loading="loading"
      confirm-btn-class-name="bg-accent hover:bg-accent-hover focus:bg-accent-hover text-light"
      :on-cancel="handleClose"
      :on-confirm="top"
    />
  </div>
</template>

<script setup>
import { API_ENDPOINTS } from "@utils/api/endpoints";
import { useCustomerStore } from '@stores/customer';
import { useSelectedStore } from '@stores/selected';
import ConfirmationCard from "@components/common/confirmation-card";
import ToppingIcon from "@components/icons/topping-icon";

const { t } = useI18n();
const { $eventBus, $toast } = useNuxtApp();
const customer = useCustomerStore();
const store = useSelectedStore();
const loading = ref(false);

const resolvedCount = computed(() => customer?.supplier?.availableInspirationPoints ?? 0);

const handleClose = () => {
  $eventBus.emit('modal:close');
  if (store.action === 'RETURN_TO_PRODUCT_MODAL') {
    $eventBus.emit('modal:open', 'PRODUCT_DETAILS');
    store.setAction(null);
  }
};

const top = async () => {
  if (loading.value || !checkAuth() || resolvedCount.value < 10) {
    return;
  }

  loading.value = true;
  const { data, error, status } = await useApiFetch(API_ENDPOINTS.ESHOP_PRODUCT_VARIANT_ID_TOP, {
    method: 'POST',
    path: {
      idVariant: store.variant.id
    }
  });
  if (status.value === 'error') {
    $toast.success(t('error.variant.top.unknown'));
    sentryCaptureEvent({
      message: 'variant-topping',
      level: 'error',
      extra: { error: error.value }
    });
    loading.value = false;
    return;
  }

  $eventBus.emit('variant:update', {
    id: store.variant.id,
    top: data.value.top,
    topEndsAt: data.value.topEndsAt
  });
  customer.supplier.availableInspirationPoints -= 10;
  $toast.success(t('success.variant.top.activated'));
  await loadSupplier();
  handleClose();
};
</script>
